

































import {
  Vue,
  photosUrlEnum,
  servicesURL,
  headers
} from "../../constants/constants";
import { updatePhotosURL,URLBuilder,isRTL } from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import * as moment from "moment";
import axios from "axios";

export default Vue.component("trackingBanner", {
  data() {
    return {isRTL ,URLBuilder, moment, staticContent, photosUrlEnum, orderTracking: null };
  },
  props: {},

  beforeCreate() {
    this.$store.dispatch("GET_LAST_ACTIVE_ORDER");
  },
  mounted() {
    //Start tracking order
    this.lastOrder.orderUUID &&
    (this.orderTracking = setInterval(() => {
       if(this.profile && this.profile.data.profile){
      this.getOrderStateDetails(this.lastOrder.orderUUID);
       }
       else{
          
            this.stopTracking();
          
       }
    }, 20000))
  },
  updated(){
    if(!this.orderTracking)
    {
    this.lastOrder.orderUUID &&
    (this.orderTracking = setInterval(() => {
       if(this.profile && this.profile.data.profile){
      
      this.getOrderStateDetails(this.lastOrder.orderUUID);
       }
       else{
         this.stopTracking();
       }
    }, 20000));
    }

    if( this.lastOrder.data 
&& this.lastOrder.data.orderStateEnum == 'INSPECTING' && 
this.bindConditionalClasses.indexOf("resume-order-modal") <= -1)
{this.getOrderStateDetails(this.lastOrder.orderUUID);}
    
  },
  computed: {
    bindConditionalClasses(){
      return this.$root.bindConditionalClasses;
    },
    profile(){
      return this.$root.profile;
    },
      lang(){
        return this.isRTL ? 'AR' : 'EN'
      },
    lastOrder() {
      return this.$store.state.lastOrder;
    },
    estimatedDelivery() {
      return moment(
        this.lastOrder.data.acceptedTime || this.lastOrder.data.createdAt
      )
        .add(this.lastOrder.data.estimatedDeliveryTime, "minutes")
        .locale(isRTL ? "ar-ly" : 'en')
        .format("hh:mm a");
    },
    resumeOrder() {
      return this.$root.resumeOrder;
    }
  },

  methods: {
   modalToggler(modal,method){
     return this.$root.modalToggler(modal,method)
   },
    stopTracking() {
      clearInterval(this.orderTracking);
    },
    updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG) {
      return updatePhotosURL(url, version, ext);
    },
    getOrderStateDetails(orderUUID) {
      axios({
        method: "GET",
        url: servicesURL.order.selectedOrderStateDetails(orderUUID),
        headers
      })
        .then(res => {
          this.$store.commit("updateLastOrderState", res.data);
          if (res.data.state == "CANCELED" || res.data.state == "REJECTED" || res.data.state == "DELIVERED") {
            this.stopTracking();
            this.resumeOrder.uuid == orderUUID &&
              (this.resumeOrder.cancelLoading = false);
          }
          this.lastOrder.data.orderStateEnum !== "INSPECTING" &&
            this.modalToggler("resume-order-modal", "hide");
          let rejectionReasons = [
            "REJECTED_ADDRESS_NOT_CLEAR",
            "REJECTED_INSUFFICIENT_FUNDS"
          ];
          if (
            rejectionReasons.indexOf(this.lastOrder.data.actionType) > -1 &&
            this.lastOrder.data.orderStateEnum == "INSPECTING" &&
            this.bindConditionalClasses.indexOf("resume-order-modal") <= -1
          ) {
            this.resumeOrder.uuid = orderUUID;
            this.resumeOrder.reason = this.lastOrder.data.actionType;
            if (this.lastOrder.ref.userUUID == this.profile.uuid) {
              this.resumeOrder.ref = this.lastOrder.ref;
              this.resumeOrder.data = this.lastOrder.data;
              this.modalToggler("resume-order-modal", "show");
            }
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  }
});
